<template>
<div class="body apply">
    <div class="wrap" style="width: inherit !important;">
        <div class="apply-menu-wrap1">
            <div class="top-menu">
                <h1>
                    <img v-if="logo" :src="logo" alt="company logo">
                    <div v-else style="height: 25px;" />
                    <!-- <span>사내어학과정</span> -->
                    <div style="height:30px;"></div>
                </h1>
                <!-- 모바일용 -->
                <a href="#" class="dp-inblock-m m-menu" id="header-menu-btn">
                    <img src="../../assets/img/m_gnb_sub.png" alt="menu">
                </a>
                <ul>
                    <li class="on-blue">
                        <a>신청하기</a>
                    </li>
                    <li>
                        <a class="pointer">신청내역 확인</a>
                    </li>
                    <!-- <li :class="{'on-blue' : pageType === 'pw'}">
                        <a class="pointer" @click="moveFixPW()">비밀번호 재설정</a>
                    </li> -->
                    <li>
                        <a class="pointer">Logout</a>
                    </li>
                </ul>
            </div>
            <!-- 반응형 메뉴 -->
            <div class="dp-inblock-m m-top-menu" id="header-menu">
                <a href="#" class="close" id="header-close">
                    <img src="../../assets/img/menu_close.png" alt="">
                </a>
                <ul class="clear">
                    <li><a class="pointer">신청하기</a></li>
                    <li><a class="pointer">신청내역 확인</a></li>
                    <!-- <li><a class="pointer" @click="moveFixPW()">비밀번호 재설정</a></li> -->
                    <li><a class="pointer">Logout</a></li>
                </ul>
            </div>
        </div>
        <div class="con">
            <div class="title">
                <h2>결제</h2>
                <p><br></p>
            </div>
            <progress-bar></progress-bar>
            <div class="mt-50">
                <div class="apply-fieldset">
                    <div class="apply-program-wrap">
                        <div class="apply-select-number">
                            선택한 과정 <span class="txt-red">(2)</span>
                            <button class="pointer">다시 선택하기</button>
                        </div>
                        <div class="apply-program-select">
                            <ul>
                                <!-- 선택 했을 경우 -->
                                <li class="program-select blue">
                                    <div class="apply-program-unit">
                                        <ul>
                                            <!-- 선택한 컬러로 클래스 노출, class="blue" -->
                                            <li class="unit-title blue" data-toggle="modal" data-target="#program-info">
                                                <h4 class="pay-title">미리보기 과목명 (1)</h4>
                                                <img src="../../assets/img/close.png" class="pointer" alt="">
                                            </li>
                                            <li>
                                                <p>
                                                    <span>언어 <b class="bold">미리보기 영어</b></span>
                                                </p>
                                                <p>
                                                    <span>스케쥴 <b class="bold">2020-01-01 ~ 2020-12-31</b></span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    <span>교육비 <b class="bold">50,000원</b></span>
                                                </p>
                                                <p>
                                                    <span>교재비 <b class="bold">50,000원</b></span>
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                                <li class="program-select blue">
                                    <div class="apply-program-unit">
                                        <ul>
                                            <!-- 선택한 컬러로 클래스 노출, class="blue" -->
                                            <li class="unit-title blue" data-toggle="modal" data-target="#program-info">
                                                <h4 class="pay-title">미리보기 과목명 (2)</h4>
                                                <img src="../../assets/img/close.png" class="pointer" alt="">
                                            </li>
                                            <li>
                                                <p>
                                                    <span>언어 <b class="bold">미리보기 영어</b></span>
                                                </p>
                                                <p>
                                                    <span>스케쥴 <b class="bold">2020-01-01 ~ 2020-12-31</b></span>
                                                </p>
                                            </li>
                                            <li>
                                                <p>
                                                    <span>교육비 <b class="bold">50,000원</b></span>
                                                </p>
                                                <p>
                                                    <span>교재비 <b class="bold">50,000원</b></span>
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="hq-table-row">
                        <h3>신청자 정보</h3>
                        <table>
                            <colgroup>
                                <col width="30%">
                                <col width="70%">
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th>이름</th>
                                    <td>홍길동</td>
                                </tr>
                                <tr>
                                    <th>E-mail</th>
                                    <td>test@carrotglobal.com</td>
                                </tr>
                                <tr>
                                    <th>휴대전화번호</th>
                                    <td>010-0000-0000</td>
                                </tr>
                                <tr>
                                    <th>회사</th>
                                    <td>캐럿솔루션즈</td>
                                </tr>
                                <tr>
                                    <th>직급</th>
                                    <td>대리</td>
                                </tr>
                                <tr>
                                    <th>부서</th>
                                    <td>솔루션개발팀</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="hq-table-row">
                        <h3>결제 정보</h3>
                        <table>
                            <colgroup>
                                <col width="30%">
                                <col width="70%">
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th>결제금액</th>
                                    <td>200,000원</td>
                                </tr>
                                <tr>
                                    <th>결제방법</th>
                                    <td>
                                        <label for="card" v-show="payWay.pay_way === 'C'">
                                            <input type="radio" v-model="payType" name="payTypeC" id="" value="card">
                                            <span class="txt-13px ml-05 mr-20">카드결제</span>
                                        </label>
                                        <label for="pay" v-show="payWay.pay_way === 'A'">
                                            <input type="radio" v-model="payType" name="payTypeA" id="" value="trans">
                                            <span class="txt-13px ml-05 mr-20">실시간 계좌이체</span>
                                        </label>
                                        <label for="pay" v-show="payWay.pay_way === 'D'">
                                            <input type="radio" v-model="payType" name="payTypeD" id="" value="card">
                                            <span class="txt-13px ml-05 mr-20">카드결제</span>
                                            <input type="radio" v-model="payType" name="payTypeD" id="" value="trans">
                                            <span class="txt-13px ml-05 mr-20">실시간 계좌이체</span>
                                        </label>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="apply-agree-btn">
                <button type="button">수강신청 하기</button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    GetUrlParams
} from '@/utils/common.js'
import Vue from 'vue'
const EventBus = new Vue()
export default {
    data: () => ({
        sessionData: {}, // 세션 스토리지 수강신청 등록 전체 데이터
        info: [], // 전 페이지에서 사용자 정보 입력된 데이터
        payWay: {}, // 지불 방법 
        totalPayment: 0, // 결제 최종 금액
        payType: 'card', // card: 카드결제, trans: 실시간 계좌이체
        merchantUid: '', // api 결제 승인났을때 고유 아이디 받음 (이 아이디로 iamport에 사용)
        orderId: '', // 주문 id
        impUid: '', // imp id
        isDetailModalOpened: false, // 과정 상세보기 레이어팝업 on/off
        parentData: {}, // 레이어팝업에 전달할 해당 강의 데이터

        payWayP: 'C', // 지불 방법
        partialPay: 'A', // 전체결제 A 부분결제 P

        logo: '' // 미리보기 로고 url용
    }),

    beforeUpdate() {
        console.log('payment update')
    },

    beforeDestroy() {
        EventBus.$off('paymentComp')
    },

    watch: {
        // 등록 페이지 내의 현재 라우터 경로 감지
        // Watch에 넣어놓은 이유는 keep-alive 사용으로 페이지 진입후 재진입할때 mount가 안되기 때문
        '$route'() {
            if (this.$route.fullPath === '/user/reg/payment') {
                this.loadSugangData()
            }
        }
    },

    mounted() {
        var oParams = GetUrlParams()
        this.mainIdx = oParams.mainIdx

        var idx = this.mainIdx
        // var params = {
        //     idx: idx
        // }
        this.axios.get(this.axios.root + this.axios.port + `/sugang/pay-way/${idx}`)
            .then(res => {
                console.log('res', res)
                if (res.data.err === 0) {
                    this.logo = res.data.payWay.company_logo_file_url
                    this.payWay = res.data.payWay

                    if (this.payWay.pay_way === 'C') {
                        this.payType = 'card'
                        this.payWayP = 'C'
                    } else if (this.payWay.pay_way === 'A') {
                        this.payType = 'trans'
                        this.payWayP = 'A'
                    }

                    if (res.data.payWay.partial_pay) {
                        this.partialPay = res.data.payWay.partial_pay
                    }

                    console.log('payWay', this.payWay)
                } else {
                    alert(res.data.result)
                }
            })

        EventBus.$on('paymentComp', (orderId, impUid) => {
            console.log('orderId', orderId)
            console.log('impUid', impUid)

            let params = new URLSearchParams()
            params.append('orderId', orderId)
            params.append('impUid', impUid)

            this.axios.post(this.axios.root + this.axios.port + "/pay/confirm", params)
                .then(res => {
                    console.log('결제 최종 res', res)
                    if (res.data.err === 0) {
                        alert('결제가 완료되었습니다.')
                        console.log('fsdfsdfsd ', orderId)
                        this.save(orderId)
                    } else {
                        alert(res.data.result)
                    }
                })
        })
    },

    methods: {
        // 선택한 과정 삭제 
        deleteClass(idx) {
            this.totalPayment -= (this.sessionData.classList[0].subjectList[idx].eduPrice + this.sessionData.classList[0].subjectList[idx].bookPrice)
            this.sessionData.classList[0].subjectList.splice(idx, 1)
        },

        // 과정선택 페이지로 이동
        moveSelectPage() {
            this.$router.push('/user/reg/select')
        },

        // 세션 스토리지 수강신청 전체 데이터 loading
        loadSugangData() {
            this.sessionData = JSON.parse(sessionStorage.getItem("classData"));
            console.log('sessionData', this.sessionData)
            this.info = this.sessionData.info
            this.totalPayment = this.sessionData.totalPayment

            for (var item of this.info) {
                if (item.item_name === '이름') {
                    this.name = item.value
                    console.log('item.value', item.value)
                } else if (item.item_name.includes('E-mail@')) {
                    console.log('item.value', item.value)
                    this.email = item.value
                }
            }
        },

        // 숫자 1000 단위로 콤마찍기 (1000 => 1,000)
        numberFormat(inputNumber) {
            console.log(inputNumber, inputNumber)
            return inputNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },

        // 수강신청 전체 데이터 저장
        save(orderId) {
            // let params = new URLSearchParams()
            // params.append('orderId', orderId)
            // params.append('impUid', impUid)
            delete this.sessionData['info']
            delete this.sessionData['totalPayment']

            // this.sessionData['idxItmSugangPageMain'] = 1
            this.sessionData['mobile'] = '010-9759-3585'
            this.sessionData['number'] = '5'
            this.sessionData['partialPay'] = this.partialPay
            this.sessionData['payStatus'] = 'N'
            this.sessionData['position'] = 'manager'
            this.sessionData['payWay'] = this.payWayP
            this.sessionData['orderId'] = orderId
            // this.sessionData['userIdx'] = 1
            // 테스트데이터 
            this.sessionData['optionContents1'] = '5'
            this.sessionData['optionContents2'] = '5'
            this.sessionData['optionContents3'] = '5'
            this.sessionData['optionContents4'] = '5'
            this.sessionData['optionContents5'] = '5'
            this.sessionData['optionName1'] = '5'
            this.sessionData['optionName2'] = '5'
            this.sessionData['optionName3'] = '5'
            this.sessionData['optionName4'] = '5'
            this.sessionData['optionName5'] = '5'

            let params = this.sessionData
            console.log('params!!!', params)
            this.axios.post(this.axios.root + this.axios.port + "/user/apply", params)
                .then(res => {
                    console.log('최종 저장 res', res)
                    if (res.data.err === 0) {
                        var pOrder = JSON.parse(sessionStorage.getItem("pOrder"));
                        var idx = pOrder.indexOf('payment') + 1
                        sessionStorage.setItem('step', pOrder[idx])
                        sessionStorage.setItem("classData", JSON.stringify(this.sessionData));
                        this.$router.push(`/user/reg/${pOrder[idx]}`)
                    } else {
                        alert(res.data.result)
                    }
                })
        },

        // 수강신청 하기
        apply() {
            if (this.sessionData.classList[0].subjectList.length === 0) {
                alert('선택한 과정이 1개 이상 있어야 합니다.')
                return false
            }

            if (this.payType === 'card') {
                this.payWayP = 'C'
            } else if (this.payType === 'trans') {
                this.payWayP = 'A'
            }

            var params = []
            for (var item of this.sessionData.classList[0].subjectList) {
                var tempQuery = {
                    bookPriceYN: 'Y',
                    idxItmSugangPageMain: this.sessionData.classList[0].idxItmSugangPageMain,
                    // idxItmSugangStudent: 1,
                    idxItmSugangSubject: item.subjectIdx,
                    name: this.name,
                    email: this.email,
                    payWay: this.payWayP,
                    partialPay: this.partialPay,
                    status: 'N',
                    price: item.eduPrice + item.bookPrice,
                    subjectName: item.subjectName,
                    totalPrice: this.totalPayment
                }
                params.push(tempQuery)
                console.log(item)
            }

            this.axios.post(this.axios.root + this.axios.port + '/pay/check', params)
                .then(res => {
                    console.log('res', res)
                    if (res.data.err === 0) {
                        this.merchantUid = res.data.merchantUid

                        var IMP = window.IMP; // 생략가능
                        // IMP.init('imp28895051'); // Carrotglobal Iamport 실제 IMP코드
                        IMP.init('imp36837262'); // 테스트 imp코드
                        IMP.request_pay({
                            pg: 'inicis', // version 1.1.0부터 지원.
                            pay_method: this.payType,
                            merchant_uid: this.merchantUid,
                            // merchant_uid: '123',
                            name: '주문명:' + this.sessionData.classList[0].className,
                            amount: this.totalPayment,
                            buyer_email: this.email,
                            buyer_name: this.name,
                            buyer_tel: '',

                            // pg: 'inicis', // version 1.1.0부터 지원.
                            // pay_method: 'card',
                            // // merchant_uid: 'merchant_' + new Date().getTime(),
                            // merchant_uid: res.data.merchantUid,
                            // name: '주문명:' + this.productName,
                            // amount: this.quantity * this.price,
                            // buyer_email: this.userEmail,
                            // buyer_name: this.userName,
                            // buyer_tel: this.userPhone,

                            // buyer_addr: '서울특별시 광진구 중곡4동 영화사로9길 24',
                            // buyer_postcode: '123-456',
                            // TODO: 상용 배포시 바꿔야함
                            // m_redirect_url: this.axios.root + '/purchaseComplete'
                            // m_redirect_url: 'https://www.yourdomain.com/payments/complete'
                        }, function (rsp) {
                            console.log('rsp', rsp)

                            if (rsp.success) {
                                var msg = '결제가 완료되었습니다.';
                                msg += '고유ID : ' + rsp.imp_uid;
                                msg += '상점 거래ID : ' + rsp.merchant_uid;
                                msg += '결제 금액 : ' + rsp.paid_amount;
                                msg += '카드 승인번호 : ' + rsp.apply_num;

                                this.orderId = rsp.merchant_uid
                                this.impUid = rsp.imp_uid

                                EventBus.$emit('paymentComp', rsp.merchant_uid, rsp.imp_uid)
                            } else {
                                msg = '결제에 실패하였습니다.';
                                msg += '에러내용 : ' + rsp.error_msg;
                                alert(msg)
                                this.$router.push('/user/reg/payment')
                            }
                        });

                    } else {
                        alert(res.data.result)
                    }
                }).catch(err => {
                    console.log('err', err)
                    alert(err)
                })

            // this.$router.push('/user/reg/complete')
        },

        // 과정 상세보기 레이어팝업 열기
        openModal(data) {
            this.parentData = data
            this.isDetailModalOpened = true
        },

        // 모달 닫기
        closeModal() {
            this.isDetailModalOpened = false
        }
    }
}
</script>
